const config = {
  //  imageBaseURL: 'http://localhost:8080/serviceapp'   
  imageBaseURL: 'https://docmaster.spaplc.com/serviceapp/'           // for image links
};

export default config;